import { UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { StyledRow } from "Pages/MyBatchesAntd/MyBatchesHeaderAntd";
import { Col, Form, Select } from "antd";
import React, { useContext } from "react";
import { academicPhase } from "utilFunctions/Constants/Constants";
import MutlSelectAntdComponent from "utilFunctions/shared/AntdSharedComponents/MutlSelectAntdComponent";
interface PlannerFilterFormFieldCompIF {
  filterState: any;
  form: any;
  onChange: any;
  isRequired: boolean;
}
export const filterOption = (input: string, option: any) => {
  return (option?.label.toString() ?? "")
    .toLowerCase()
    .includes(input.toLowerCase());
};
const PlannerFilterFormFieldComp = ({
  filterState,
  form,
  onChange,
  isRequired,
}: PlannerFilterFormFieldCompIF) => {
  const { masters } = useMasterContext();
  const userInfo = useContext<any>(UserInfoContext);
  return (
    <StyledRow gutter={[10, 0]} screen={screen}>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          label="Stream"
          name="streamId"
          rules={[{ required: isRequired, message: "Please select stream" }]}
        >
          <Select
            showSearch
            defaultValue={
              filterState.streamList ? filterState.streamList : null
            }
            style={{ width: "100%" }}
            size="middle"
            options={masters?.streams}
            onChange={(val) => onChange("streamList", val)}
            filterOption={filterOption}
          />
        </Form.Item>
      </Col>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          label="Academic year"
          name={"acadYearId"}
          rules={[
            { required: isRequired, message: "Please select academic year" },
          ]}
        >
          <Select
            showSearch
            defaultValue={
              filterState.acadYearList ? filterState.acadYearList : null
            }
            style={{ width: "100%" }}
            size="middle"
            options={masters?.acadYears}
            onChange={(val) => onChange("acadYearList", val)}
            filterOption={filterOption}
          />
        </Form.Item>
      </Col>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          label="Class"
          name={"classList"}
          rules={[{ required: isRequired, message: "Please select Class" }]}
        >
          <MutlSelectAntdComponent
            options={masters?.classes}
            placeholder=""
            form={form}
            defaultValues={filterState.classList ? filterState.classList : null}
            onChangeHandler={(val) => {
              if (val && val.length) {
                onChange("classList", val);
              } else {
                onChange("classList", null);
              }
            }}
            name={"classList"}
          ></MutlSelectAntdComponent>
        </Form.Item>
      </Col>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item label="Phase" name={"phaseList"}>
          <MutlSelectAntdComponent
            options={academicPhase}
            placeholder=""
            form={form}
            defaultValues={filterState.phaseList ? filterState.phaseList : null}
            onChangeHandler={(val) => {
              if (val && val.length) {
                onChange("phaseList", val);
              } else {
                onChange("phaseList", null);
              }
            }}
            name="phaseList"
          ></MutlSelectAntdComponent>
        </Form.Item>
      </Col>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item label="Subject" name={"subjectList"}>
          <MutlSelectAntdComponent
            options={userInfo?.subjectsListing}
            placeholder=""
            form={form}
            defaultValues={
              filterState.subjectList ? filterState.subjectList : null
            }
            onChangeHandler={(val) => {
              if (val && val.length) {
                onChange("subjectList", val);
              } else {
                onChange("subjectList", null);
              }
            }}
            name="subjectList"
          ></MutlSelectAntdComponent>
        </Form.Item>
      </Col>
    </StyledRow>
  );
};

export default PlannerFilterFormFieldComp;
